import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "arrow-left",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M10 13.78C9.87333 13.78 9.74667 13.7333 9.64667 13.6333L5.3 9.28667C4.59333 8.58 4.59333 7.42 5.3 6.71333L9.64667 2.36667C9.84 2.17333 10.16 2.17333 10.3533 2.36667C10.5467 2.56 10.5467 2.88 10.3533 3.07333L6.00667 7.42C5.68667 7.74 5.68667 8.26 6.00667 8.58L10.3533 12.9267C10.5467 13.12 10.5467 13.44 10.3533 13.6333C10.2533 13.7267 10.1267 13.78 10 13.78Z",
			fill: "#7548F0"
		}), /* @__PURE__ */ _jsx("g", {
			id: "Vector_2",
			opacity: 0
		})]
	})
});
export default SvgWalletArrowLeft;
